module.exports = __webpack_public_path__ + "fonts/montserrat-extrabold.1944c8d.ttf";